module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wc-input-wrapper",
    class: {
      'has-error': _vm.invalid, 'has-success': _vm.isDirty, 'i-am-sunny': _vm.disabled
    }
  }, [(_vm.label) ? _c('label', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    class: {
      'i-am-sunny': _vm.disabled
    },
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.update,
      "blur": _vm.touch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "help-block animated fadeInDown"
  }, [(_vm.invalid && (_vm.customErrorMsg || _vm.errorMsg)) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.customErrorMsg || _vm.errorMsg) + "\n        ")]) : _c('span', {
    staticClass: "ghostly"
  }, [_vm._v("\n             \n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30593e9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/forms/wc-input.vue
// module id = 815
// module chunks = 3